/**
 * Client-seitige Moderation – Phase 1.
 *
 * Der Browser der ZUSCHAUENDEN Person prüft das eingehende Video lokal und blendet es bei
 * Verdacht aus. Das schützt die Person vor dem Bildschirm und lässt sich von der sendenden Seite
 * nicht aushebeln (anders als eine Prüfung des eigenen, ausgehenden Videos). Kein Bild verlässt
 * dabei das Gerät.
 *
 * Grenzen: ersetzt keine Moderation mit Server und Menschen (Phase 2), erkennt kein Alter und
 * ist kein rechtlicher Schutzschild.
 *
 * Stand: Schnittstelle und Einbindung in den Chat stehen, als Engine läuft ein Platzhalter.
 * Nächster Schritt: ein NSFW-Klassifikator (z. B. nsfwjs auf TensorFlow.js, erst bei Bedarf
 * geladen) als ModerationEngine – siehe docs/ROADMAP.md.
 */

export interface ModerationVerdict {
  unsafe: boolean;
  /** 0–1, wie sicher sich das Modell ist */
  score: number;
}

export interface ModerationEngine {
  readonly name: string;
  /** Prüft das aktuell sichtbare Standbild des Videos. */
  classify(video: HTMLVideoElement): Promise<ModerationVerdict>;
}

/** Platzhalter – prüft nichts. */
export const disabledEngine: ModerationEngine = {
  name: 'deaktiviert',
  classify: () => Promise.resolve({ unsafe: false, score: 0 }),
};

export function loadModerationEngine(): Promise<ModerationEngine> {
  return Promise.resolve(disabledEngine);
}
